export class Syllabus {
    id=0
    syllabusCode=""
    description=""
    server_syllabus_id=0
    prefix=""
    topics=[]

    formData(){
        let body = new URLSearchParams();
        body.set('syllabusCode', this.syllabusCode);
        body.set('server_syllabus_id', this.id.toString());
        body.set('description', this.description);
        body.set('prefix', this.prefix);
        return body.toString()
      }

}
